export const initialState = () => ({
  term: {
    uuid: "",
    status: "",
    created_at: "",
    title: "",
    content: "",
    deactivated_at: null,
    scheduled_at: null,
    version: ""
  },
  isEditing: false
})
